module.exports = __webpack_public_path__ + "static/media/climatizacion-coche.835c6a6c.png";